{
  "metadata": {
    "id": "aura-light",
    "name": "Aura",
    "description": "Портировано из темы «Aura» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "aura.json",
      "project": "daltonmenezes",
      "url": "https://github.com/daltonmenezes/aura-theme",
      "upstreamFile": "packages/ui/src/theme/themes/aura.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 23.4,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.47,
      "paletteMaxS": 0.514,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 24.8,
      "syntaxVsTextMinDeltaE": 18.2,
      "chartsMinDeltaE": 45.8,
      "textSeparationDeltaE": 14.9,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "string",
          "b": "type",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#9b6dff",
      "hover": "#8c62e6",
      "active": "#7f59d1",
      "foreground": "#000000",
      "muted": "#9b6dff80",
      "emphasis": "#9b6dff"
    },
    "surface": {
      "background": "#f5f0ff",
      "foreground": "#2d2640",
      "muted": "#c7c2d4",
      "mutedForeground": "#45414e",
      "elevated": "#b2acc0",
      "elevatedForeground": "#2d2640",
      "raised": "#9791a7",
      "raisedForeground": "#2d2640",
      "overlay": "#f5f0ff33",
      "subtle": "#ded9ea"
    },
    "interactive": {
      "border": "#908aa1",
      "borderHover": "#bdb7ca",
      "borderFocus": "#9b6dff",
      "selection": "#2d264024",
      "selectionForeground": "#2d2640",
      "focus": "#9b6dff59",
      "focusRing": "#9b6dff47",
      "cursor": "#2d2640",
      "hover": "#2d264017",
      "active": "#2d264024"
    },
    "status": {
      "error": "#d22d2d",
      "errorForeground": "#ffffff",
      "errorBackground": "#d22d2d1a",
      "errorBorder": "#d22d2d59",
      "warning": "#90641e",
      "warningForeground": "#ffffff",
      "warningBackground": "#90641e1a",
      "warningBorder": "#90641e59",
      "success": "#297a4e",
      "successForeground": "#ffffff",
      "successBackground": "#297a4e1a",
      "successBorder": "#297a4e59",
      "info": "#227593",
      "infoForeground": "#ffffff",
      "infoBackground": "#2275931a",
      "infoBorder": "#22759359"
    },
    "pr": {
      "open": "#297a4e",
      "draft": "#544f5f",
      "blocked": "#90641e",
      "merged": "#d94f4f",
      "closed": "#d22d2d"
    },
    "syntax": {
      "base": {
        "background": "#c7c2d4",
        "foreground": "#2d2640",
        "comment": "#544f66",
        "keyword": "#5328d5",
        "string": "#1c5b3a",
        "number": "#9b2222",
        "function": "#724717",
        "variable": "#2d2640",
        "type": "#1c5b3a",
        "operator": "#232f2c"
      },
      "tokens": {
        "commentDoc": "#544f66",
        "stringEscape": "#232f2c",
        "keywordImport": "#5328d5",
        "storageModifier": "#5328d5",
        "functionCall": "#724717",
        "method": "#724717",
        "variableProperty": "#724717",
        "variableOther": "#2d2640",
        "variableGlobal": "#9b2222",
        "variableLocal": "#232f2c",
        "parameter": "#2d2640",
        "constant": "#9b2222",
        "class": "#1c5b3a",
        "className": "#1c5b3a",
        "interface": "#1c5b3a",
        "struct": "#1c5b3a",
        "enum": "#1c5b3a",
        "typeParameter": "#1c5b3a",
        "namespace": "#1c5b3a",
        "module": "#5328d5",
        "tag": "#5328d5",
        "jsxTag": "#5328d5",
        "tagAttribute": "#724717",
        "tagAttributeValue": "#1c5b3a",
        "boolean": "#9b2222",
        "decorator": "#5328d5",
        "label": "#724717",
        "regexp": "#1c5b3a"
      }
    },
    "charts": {
      "series": [
        "#9b6dff",
        "#227593",
        "#297a4e",
        "#90641e",
        "#d22d2d"
      ]
    },
    "chat": {
      "background": "#f5f0ff",
      "userMessage": "#2d2640",
      "userMessageBackground": "#b2acc0",
      "assistantMessage": "#2d2640",
      "assistantMessageBackground": "#c7c2d4",
      "timestamp": "#544f5f",
      "divider": "#908aa1",
      "typing": "#544f5f"
    },
    "loading": {
      "spinner": "#9b6dff",
      "spinnerTrack": "#c7c2d4",
      "skeleton": "#c7c2d4",
      "shimmer": "#beb9cb"
    },
    "tools": {
      "background": "#c7c2d4",
      "border": "#908aa1",
      "headerHover": "#bfbacd",
      "icon": "#7c3fff",
      "title": "#2d2640",
      "description": "#544f5f",
      "edit": {
        "added": "#297a4e",
        "addedBackground": "#297a4e1a",
        "removed": "#d22d2d",
        "removedBackground": "#d22d2d1a",
        "modified": "#227593",
        "modifiedBackground": "#2275931a",
        "lineNumber": "#544f5f"
      }
    },
    "markdown": {
      "heading1": "#2d2640",
      "heading2": "#2d2640",
      "heading3": "#2d2640",
      "heading4": "#2d2640",
      "link": "#7f44ff",
      "linkHover": "#7f50e3",
      "inlineCode": "#1c5b3a",
      "inlineCodeBackground": "#c7c2d4",
      "blockquote": "#544f5f",
      "blockquoteBorder": "#908aa1",
      "listMarker": "#9868ff",
      "bold": "#2d2640",
      "italic": "#2d2640e6",
      "strikethrough": "#544f5f",
      "hr": "#908aa1"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#d29d92",
        "foreground": "#000000",
        "contrast": 8.98
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c3644e",
        "foreground": "#000000",
        "contrast": 5.25
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c69354",
        "foreground": "#000000",
        "contrast": 7.7
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#cbc55d",
        "foreground": "#000000",
        "contrast": 11.68
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#b7d697",
        "foreground": "#000000",
        "contrast": 13.08
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#5dc959",
        "foreground": "#000000",
        "contrast": 9.96
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#5dc98b",
        "foreground": "#000000",
        "contrast": 10.19
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#7fd5bd",
        "foreground": "#000000",
        "contrast": 12.15
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#81bdcc",
        "foreground": "#000000",
        "contrast": 10.08
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#578db9",
        "foreground": "#000000",
        "contrast": 5.92
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#516ab6",
        "foreground": "#ffffff",
        "contrast": 5.14
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#444bbc",
        "foreground": "#ffffff",
        "contrast": 7.05
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#bd8bd6",
        "foreground": "#000000",
        "contrast": 7.83
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#a64fc1",
        "foreground": "#ffffff",
        "contrast": 4.66
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c3508f",
        "foreground": "#000000",
        "contrast": 4.86
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d78cb1",
        "foreground": "#000000",
        "contrast": 8.28
      }
    ]
  }
}
